import { SearchResultsListViewItem } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/SearchResultsListViewItem/SearchResultsListViewItem";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";
import { ItemsStock } from "@coworker/apprestructured/src/shared/hooks/item/useItemsStock";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";

interface SearchResultsListViewProps {
  items: Item[];
  itemCardRenderType?: SearchItemCardRenderType;
  handleItemCardClick?: (item: Item) => void;
  itemsStock: ItemsStock;
  multiSelect?: boolean;
  selectedItemNos?: string[];
  onToggleItemSelect?: (item: Item) => void;
}

export const SearchResultsListView = ({
  items,
  itemCardRenderType = SearchItemCardRenderType.link,
  handleItemCardClick = () => {},
  itemsStock,
  multiSelect = false,
  selectedItemNos = [],
  onToggleItemSelect,
}: SearchResultsListViewProps) => {
  return (
    <FixaListView id={"search-results-list-view"} size={"small"}>
      {items.map((item: Item) => (
        <SearchResultsListViewItem
          key={item.no}
          item={item}
          itemStock={itemsStock[item.no]}
          itemCardRenderType={itemCardRenderType}
          handleItemCardClick={handleItemCardClick}
          multiSelect={multiSelect}
          isSelected={selectedItemNos.includes(item.no)}
          onToggleItemSelect={onToggleItemSelect}
        />
      ))}
    </FixaListView>
  );
};
